import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { User, getCardColor, getTextColor, formatName } from './elements'
import { BubbleTitle } from '../elements'

const Wrapper = styled.div``

const BottomWrapper = styled.div<{ $color: string }>`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex: 1;
  position: relative;
  padding-left: 20px;
  color: ${props => props.$color};
`

const PointsWrapper = styled.div`
  color: currentColor;
  display: flex;
  flex-direction: column;
  padding: 0 20px 10px 0;
  &[aria-hidden='true'] {
    visibility: hidden;
  }
`

const PointsAlign = styled.div`
  display: flex;
  align-items: baseline;
`

const PointsValue = styled.p`
  display: inline;
  font-size: 36px;
  font-weight: 400;
  line-height: 44px;
  margin: 0;
`

const PointsText = styled.p`
  display: inline;
  letter-spacing: -0.5px;
  font-size: 14px;
  line-height: 16px;
  margin: 0;
  opacity: 0.6;
`

type Details = {
  overall?: string
  maximum?: string
}

type ContentProps = {
  user: User
  noDetails?: boolean
  creditDetails?: Details
  rating: string
  score: string
}

const CardContent: React.FC<ContentProps> = ({ user, noDetails, creditDetails, rating, score }) => {
  const { t } = useTranslation()
  const num = !noDetails ? creditDetails?.overall ?? 0 : 0
  const max = creditDetails?.maximum ?? 100
  const name = formatName(user)
  const label = !noDetails
    ? t('b.liv_score_card.view.overview.label', {
        defaultValue: "{{name}}'s Trust Score is {{score}} points out of {{max}}, {{rating}}",
        name,
        score: num,
        max,
        rating
      })
    : t('b.liv_score_card.view.overview_no_details.label', {
        defaultValue: "{{name}}'s Trust Score is {{rating}}",
        name,
        rating
      })
  return (
    <Wrapper aria-label={label}>
      <BottomWrapper $color={getTextColor(score)} aria-hidden>
        <PointsWrapper aria-hidden={noDetails}>
          <PointsAlign>
            <PointsValue>{num}</PointsValue>{' '}
            <PointsText>
              <span> /{max}</span>
            </PointsText>
          </PointsAlign>
        </PointsWrapper>
        <BubbleTitle
          color={getCardColor(score)}
          top={0}
          align="flex-start"
          size="small"
          label={t('r.liv_score_card.view.current_score.title', 'Trust Score')}
        >
          {rating}
        </BubbleTitle>
      </BottomWrapper>
    </Wrapper>
  )
}

export default CardContent
